import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { PropertyTypeCompany } from './property-type-company.interface';

export class PropertyTypeCompanyService {
   async getPropertyTypeCompanies(employeeId?: number, params?: LocationQuery) {
      const response = await http.get<PaginatedResponse<PropertyTypeCompany>>(`/employees/${employeeId}/property-type-companies`, {
         params,
      });
      return response.data;
   }
}
